export default "__VITE_PUBLIC_ASSET__4bf48df7__"